const Slider = ({
    label,
    bottomLabel,
    value,
    setValue,
    updateValue,
    leftLabel,
    rightLabel,
    bottomLeftLabel,
    bottomRightLabel,
    max = 100,
    min = 0,
    step,
    customOffset,
    inverse,
}: {
    label: string;
    bottomLabel?: string;
    value: number;
    setValue: any;
    updateValue?: any;
    leftLabel?: string;
    rightLabel?: string;
    bottomLeftLabel?: string;
    bottomRightLabel?: string;
    max?: number;
    min?: number;
    step?: number;
    customOffset?: number;
    inverse?: boolean;
}) => {
    const Dot = ({left}: {left: number}) => {
        return (
            <div 
                className={`slider-dot${inverse ? " inverse" : ""}`}
                style={{
                        left: `${left}%`
                    }}
            ></div>
        )
    }

    const scale = 1000;

    return (
        <div className="slider-wrapper">
            <div className="slider-value">
                <div>{leftLabel}</div>
                <div style={{textAlign: 'center'}} className="slider-label">{label}</div>
                <div style={{textAlign: 'right'}}>{rightLabel}</div>
            </div>
            <input
                type="range"
                min={min * scale}
                max={max * scale}
                step={Math.round(((step ?? 1) * scale) * 1000) / 1000}
                value={Math.min(value * scale, max * scale)}
                onChange={(e) => setValue(parseInt(e.target.value) / 1000)}
                onMouseUp={
                updateValue
                    ? (e) => updateValue(parseInt((e.target as HTMLInputElement).value) / scale)
                    : () => {}
                }
                className={inverse ? "inverse" : ""}
            />
            <div className="slider-value">
                <div>{bottomLeftLabel}</div>
                <div style={{textAlign: 'center'}} className="slider-label">{bottomLabel}</div>
                <div style={{textAlign: 'right'}}>{bottomRightLabel}</div>
            </div>
            <div className="slider-dots">
                {
                    Array.from({ length: (max - min) / (step ?? 1) + 1 }, (_, i) => (
                        <Dot key={i} left={((i * (96 + (customOffset ?? 0))) + 6) / ((max - min) / (step ?? 1))}/>
                    ))
                }
            </div>
        </div>
    );
};


export default Slider;
